export default "__VITE_ASSET__DNcEYGmH__"